import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FEATURE_NAME, KillSwitchState} from './kill-switch.state';

export const selectKillSwitchState = createFeatureSelector<KillSwitchState>(FEATURE_NAME);

export const selectIsSystemRunning = createSelector(
  selectKillSwitchState,
  (state) => !state.state && !state.emergencyStop.isActive
);

export const selectIsLoading = createSelector(
  selectKillSwitchState,
  (state) => state.isLoading
);

export const selectIsEmergencyStopConfigured = createSelector(
  selectKillSwitchState,
  (state) => state.emergencyStop.isConfigured
);

export const selectIsEmergencyStopActive = createSelector(
  selectKillSwitchState,
  (state) => state.emergencyStop.isActive
);
